const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashicorpVault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0 7.7 255 496.6L512 7.7zM215.6 205h-40.4v-40.4h40.4zm0-60.6h-40.4V104h40.4zm60.6 121.2h-40.4v-40.4h40.4zm0-60.6h-40.4v-40.4h40.4zm0-60.6h-40.4V104h40.4zm60.6 60.6h-40.4v-40.4h40.4zm-40.4-60.6V104h40.4v40.4z",
    style: {
      fill: "#ffcf25"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashicorpVault);
export default __webpack_public_path__ + "static/media/hashicorp-vault.b49e254cedfbd23b4274f308ad63c0bc.svg";
export { ForwardRef as ReactComponent };